import crud from '@/crud/index/index'

import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  mixins: [crud],

  resourcePath: 'v1/professional/agendas/rules/statistics'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/summary-agenda/resources/index.js